"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _helperComponents = require("./helperComponents");

var _withStyles = _interopRequireDefault(require("../../../utils/withStyles"));

var _styles = _interopRequireDefault(require("./styles"));

var _displayFormats = require("../utils/displayFormats");

var _getUpdatedDate = _interopRequireDefault(require("./getUpdatedDate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TimePicker = function TimePicker(_ref) {
  var classes = _ref.classes,
      label = _ref.label,
      labelPosition = _ref.labelPosition,
      date = _ref.date,
      selectTime = _ref.selectTime,
      props = _objectWithoutProperties(_ref, ["classes", "label", "labelPosition", "date", "selectTime"]);

  var _date$format$split = date.format(_displayFormats.hhmmA).split(' '),
      _date$format$split2 = _slicedToArray(_date$format$split, 2),
      hhmm = _date$format$split2[0],
      amOrPm = _date$format$split2[1];

  var _hhmm$split = hhmm.split(':'),
      _hhmm$split2 = _slicedToArray(_hhmm$split, 2),
      hour = _hhmm$split2[0],
      minute = _hhmm$split2[1];

  return _react["default"].createElement("div", _extends({
    className: classes.root
  }, props), label && _react["default"].createElement("p", {
    className: classes.label
  }, label), _react["default"].createElement("div", {
    className: classes.inputs
  }, _react["default"].createElement(_helperComponents.TimePickerInput, {
    type: "number",
    inputElAttributes: {
      min: 0,
      max: 23
    },
    value: hour,
    onChange: function onChange(e, val) {
      return selectTime(e, (0, _getUpdatedDate["default"])(val, 'hour', date));
    }
  }), _react["default"].createElement("span", null, ":"), _react["default"].createElement(_helperComponents.TimePickerInput, {
    type: "number",
    value: minute,
    inputElAttributes: {
      min: -1,
      max: 60
    },
    onChange: function onChange(e, val) {
      return selectTime(e, (0, _getUpdatedDate["default"])(val, 'minute', date));
    }
  }), _react["default"].createElement(_helperComponents.MeridiemGroup, {
    selected: amOrPm,
    onChange: function onChange(e, val) {
      return selectTime(e, (0, _getUpdatedDate["default"])(val, 'AM/PM', date));
    }
  }, _react["default"].createElement(_helperComponents.MeridiemItem, {
    value: "AM"
  }, "AM"), _react["default"].createElement(_helperComponents.MeridiemItem, {
    value: "PM"
  }, "PM"))));
};

TimePicker.propTypes = {
  classes: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  label: _propTypes["default"].string,
  labelPosition: _propTypes["default"].oneOf(['top', 'left']),
  date: _propTypes["default"].shape().isRequired,
  selectTime: _propTypes["default"].func.isRequired
};
TimePicker.defaultProps = {
  label: '',
  labelPosition: 'top'
};

var _default = (0, _withStyles["default"])(_styles["default"])(TimePicker);

exports["default"] = _default;